import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  //// FaceBook connect
  async handleFacebookCallback({ commit }, { code, userId }) {
    try {
      const client_id = "1551523535423367";
      const client_secret = "0636ff6de218b08bc9ee8430823a9e1f";
      const redirect_uri = `https://editor.getboarded.com/contact-v2?authType=fbAuth`;
      const response = await axios.get(
        `${constants.facebookGraphUrl}/v12.0/oauth/access_token?client_id=${client_id}&client_secret=${client_secret}&code=${code}&redirect_uri=${redirect_uri}`
      );
      const access_token = response.data.access_token;
      const userResponse = await axios.get(
        `${constants.facebookGraphUrl}/v12.0/me?access_token=${access_token}&fields=id,name,email`
      );
      const userData = userResponse.data;
      if (userData.id) {
        const payload = {
          userId: userData.id,
          username: userData.name,
        };
        const accessToken = localStorage.getItem("accessToken");
        const response = await axios.post(
          `${constants.gatewayUrl}/editor/contact/facebook/${userId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,              
            },
          }
        );
        if (response.data.status === "SUCCESS") {
          const response = await axios.get(
            `${constants.gatewayUrl}/editor/contact/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          const fbData = response.data.data.facebook;
          if (fbData) {
            commit("setFbData", fbData);
            commit("setIsFbVerified", true);
          }
        }
      }
    } catch (error) {
      throw error;
    }
  },
  //// FaceBook Data
  async getFaceBookData({ commit }, { userId }) {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${constants.gatewayUrl}/editor/contact/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const fbData = response.data.data.facebook;
      if (fbData) {
        commit("setFbData", fbData);
        commit("setIsFbVerified", true);
      }
    } catch (error) {
      throw error;
    }
  },
  //// Slack Connect
  async handleSlackCallback({ commit }, { code, userId }) {
    try {
      const clientId = "5316349728481.6954774661440";
      const clientSecret = "ff8277b53b010cfc82b307a5c05cc0ea";
      const redirectUri = `https://editor.getboarded.com/contact-v2?authType=slackAuth`;
      const response = await axios.post(
        `${constants.slackUrl}/api/oauth.v2.access`,
        new URLSearchParams({
          client_id: clientId,
          client_secret: clientSecret,
          code: code,
          redirect_uri: redirectUri,
        }).toString()
      );
      const tokenData = response.data.authed_user.access_token;
      const body = new URLSearchParams({
        token: tokenData,
      });

      const userDataResponse = await axios.post(
        `${constants.slackUrl}/api/users.identity`,
        body
      );
      const userData = userDataResponse.data;
      const gtbrddOrganizationId = "63386b52e53144001cb09ddb";
      if (userData.ok) {
        const payload = {
          gtbrddOrganizationId: gtbrddOrganizationId,
          gtbrddUserId: userId,
          userId: userData.user.id,
          username: userData.user.name,
          email: "null",
          workspaceId: userData.team.id,
        };
        const response = await axios.post(
          `${constants.gatewayUrl}/comm-bot/slack`,
          payload,
          {
            headers: {
              Authorization: "Basic R1RCUkREX0dBVEVXQVk6Z2F0ZXdheW9wZW4=",
            },
          }
        );
        if (response.data.status === "SUCCESS") {
          const accessToken = localStorage.getItem("accessToken");
          const response = await axios.get(
            `${constants.gatewayUrl}/comm-bot/slack/${gtbrddOrganizationId}/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          if (response.data.status === "SUCCESS") {
            commit("setSlackData", response.data.data);
            commit("setIsSlackVerified", true);
          }
        }
      }
    } catch (error) {
      throw error;
    }
  },
  //// Slack Data
  async getSlackData({ commit }, { userId }) {
    try {
      const gtbrddOrganizationId = "63386b52e53144001cb09ddb";
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${constants.gatewayUrl}/comm-bot/slack/${gtbrddOrganizationId}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data.data) {
        commit("setSlackData", response.data.data);
        commit("setIsSlackVerified", true);
      }
    } catch (error) {
      throw error;
    }
  },
  //// Discord Connect
  async handleDiscordCallback({ commit }, { code, userId }) {
    try {
      const clientId = "1091377219231813642";
      const clientSecret = "tgu_hA8wRaO_sx46Tg2fr8blYoIha1MD";
      const redirectUri = `https://editor.getboarded.com/contact?authType=discordAuth`;

      const response = await axios.post(
        `${constants.discordApi}/oauth2/token`,
        new URLSearchParams({
          client_id: clientId,
          client_secret: clientSecret,
          code: code,
          redirect_uri: redirectUri,
          grant_type: "authorization_code",
        }).toString()
      );
      const tokenData = response.data;
      const userDataResponse = await axios.get(
        `${constants.discordApi}/users/@me`,
        {
          headers: {
            Authorization: `Bearer ${tokenData.access_token}`,
          },
        }
      );
      const userData = userDataResponse.data;
      const gtbrddOrganizationId = "63386b52e53144001cb09ddb";
      if (userData.id) {
        const payload = {
          gtbrddOrganizationId: gtbrddOrganizationId,
          gtbrddUserId: userId,
          userId: userData.id,
          username: userData.global_name,
          email: "null",
        };
        const response = await axios.post(
          `${constants.gatewayUrl}/comm-bot/discord`,
          payload,
          {
            headers: {
              Authorization: "Basic R1RCUkREX0dBVEVXQVk6Z2F0ZXdheW9wZW4=",
            },
          }
        );
        if (response.data.status === "SUCCESS") {
          const orgId = gtbrddOrganizationId;
          const accessToken = localStorage.getItem("accessToken");
          const response = await axios.get(
            `${constants.gatewayUrl}/comm-bot/discord/${orgId}/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          if (response.data.status === "SUCCESS") {
            commit("setDiscordData", response.data.data);
            commit("setIsDiscordVerified", true);
          }
        }
      }
    } catch (error) {
      throw error;
    }
  },
  //// Discord Data
  async getDiscordData({ commit }, { userId }) {
    try {
      const gtbrddOrganizationId = "63386b52e53144001cb09ddb";
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${constants.gatewayUrl}/comm-bot/discord/${gtbrddOrganizationId}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data.data) {
        commit("setDiscordData", response.data.data);
        commit("setIsDiscordVerified", true);
      }
    } catch (error) {
      throw error;
    }
  },
  //// LinkedIn Connect
  async handleLinkedInCallback({ commit }, { code, userId }) {
    try {
      const clientId = "86u02qqn1xhmqe";
      const clientSecret = "h3XEUUqVyV5qfj22";
      const redirectUri =
        "https://editor.getboarded.com/contact-v2?authType=linkedInAuth";
      const response = await axios.post(
        "https://www.linkedin.com/oauth/v2/accessToken",
        new URLSearchParams({
          grant_type: "authorization_code",
          code: code,
          client_id: clientId,
          client_secret: clientSecret,
          redirect_uri: redirectUri,
        }).toString(),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      const tokenData = response.access_token;
      const userResponse = await axios.get(
        "https://api.linkedin.com/v2/me?projection=(id,localizedFirstName,localizedLastName,emailAddress)",
        {
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        }
      );
      const userData = userResponse.data;
      if (userData.id) {
        const payload = {
          userId: userData.id,
          username:
            userData.localizedFirstName + " " + userData.localizedLastName,
        };
        const accessToken = localStorage.getItem("accessToken");
        const response = await axios.post(
          `${constants.gatewayUrl}/editor/contact/linkedin/${userId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (response.data.status === "SUCCESS") {
          const response = await axios.get(
            `${constants.gatewayUrl}/editor/contact/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          const linkedinData = response.data.data.linkedin;
          if (linkedinData) {
            commit("setLinkedInData", linkedinData);
            commit("setIsLinkedInVerified", true);
          }
        }
      }
    } catch (error) {
      throw error;
    }
  },
  //// LinkedIn Data
  async getLinkedInData({ commit }, { userId }) {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${constants.gatewayUrl}/editor/contact/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const linkedinData = response.data.data.linkedin;
      if (linkedinData) {
        commit("setLinkedInData", linkedinData);
        commit("setIsLinkedInVerified", true);
      }
    } catch (error) {
      throw error;
    }
  },
  //// Twitter Connect
  async handleTwitterCallback({ commit }, { oAuthToken, oAuthVerifier }) {
    const accessToken = await axios.post(
      `${constants.twitterApi}/access_token?oauth_token=${oAuthToken}&oauth_verifier=${oAuthVerifier}`
    );
    console.log(accessToken);
  },
  //// Twitter Data
  async getTwitterData({ commit }, { userId }) {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${constants.gatewayUrl}/editor/contact/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data.status === "SUCCESS") {
        commit("twitterData", response.data.data.twitter);
        commit("isTwitterVerified", true);
      }
    } catch (error) {
      throw error;
    }
  },
};
